/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Appointments/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Appointments({
  children,
  viewPath = "/App/Account/WaitingRoom/Content/Content/Checkout/Appointments"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Content'
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}